import { ref, Ref } from '@vue/composition-api';
import storage from '@/renderer/scripts/utils/storage';
export function historyHandler(): {
  historyStore: Ref<string[]>;
  methods: {
    getHistory: () => void;
    setHistory: (record: string) => void;
    deleteHistory: (index: number) => void;
    clearHistory: () => void;
  };
} {
  const historyStore = ref<string[]>([]);
  const methods = {
    getHistory() {
      const record = storage.get<string[]>(storage.StoreKey.SEARCH_RECORD);
      historyStore.value = record || [];
    },
    setHistory(record: string) {
      if (!record) return;
      const index = historyStore.value.findIndex(history => history === record);
      if (index > -1) {
        historyStore.value.splice(index, 1);
      }
      historyStore.value.unshift(record);
      if (historyStore.value.length > 5) {
        historyStore.value.pop();
      }
      storage.set(storage.StoreKey.SEARCH_RECORD, historyStore.value);
    },
    deleteHistory(index: number) {
      historyStore.value.splice(index, 1);
      storage.set(storage.StoreKey.SEARCH_RECORD, historyStore.value);
    },
    clearHistory() {
      historyStore.value = [];
      storage.del(storage.StoreKey.SEARCH_RECORD);
    },
  };
  return {
    historyStore,
    methods,
  };
}
